import {EndOfDayData} from '../models'
import {assertArray, assertNumber, assertString} from '../utils'
import {AssertTypeFn} from './general'

export const endOfDayNormaliser: AssertTypeFn<EndOfDayData> = (obj) => ({
  department: assertString(obj.department),
  nurse: assertString(obj.nurse),
  maleCount: assertNumber(obj.maleCount),
  femaleCount: assertNumber(obj.femaleCount),
  undefinedGenderCount: assertNumber(obj.undefinedGenderCount),
  gpOwnCount: assertNumber(obj.gpOwnCount),
  gpNoOrNullCount: assertNumber(obj.gpNoOrNullCount),
  gpCentricCount: assertNumber(obj.gpCentricCount),
  edYesCount: assertNumber(obj.edYesCount),
  edNoOrNullCount: assertNumber(obj.edNoOrNullCount),
  scheduledCount: assertNumber(obj.scheduledCount),
  cancelledCount: assertNumber(obj.cancelledCount),
  cancelledCountExternal: assertNumber(obj.cancelledCountExternal),
  cancelledCountInternal: assertNumber(obj.cancelledCountInternal),
  rescheduledCount: assertNumber(obj.rescheduledCount),
  dnaCount: assertNumber(obj.dnaCount),
  lifestyleAndGPVisitNoOrNullCount: assertNumber(
    obj.lifestyleAndGPVisitNoOrNullCount,
  ),
  lifestyleAndGPVisitYesCount: assertNumber(obj.lifestyleAndGPVisitYesCount),
  lifestyleOnlyNoOrNullCount: assertNumber(obj.lifestyleOnlyNoOrNullCount),
  lifestyleOnlyYesCount: assertNumber(obj.lifestyleOnlyYesCount),
})

export const endOfDayListNormaliser: AssertTypeFn<EndOfDayData[]> = (arr) =>
  assertArray(arr, endOfDayNormaliser)
